import { ConversationListItem } from '@/types';
import { logger } from '@/lib/utils/logger';

interface GroupedChats {
  today: ConversationListItem[];
  yesterday: ConversationListItem[];
  lastWeek: ConversationListItem[];
  lastMonth: ConversationListItem[];
}

export function groupChatsByDate(chats: ConversationListItem[]) {
  logger.debug('[groupChatsByDate] Starting grouping:', {
    totalChats: chats.length,
    chats: chats.map((chat) => ({
      id: chat.id,
      title: chat.title,
      createdAt: new Date(chat.createdAt).toISOString(),
    })),
  });

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const lastWeek = new Date(today);
  lastWeek.setDate(lastWeek.getDate() - 7);
  const lastMonth = new Date(today);
  lastMonth.setDate(lastMonth.getDate() - 30);

  const groups = {
    today: [] as ConversationListItem[],
    yesterday: [] as ConversationListItem[],
    lastWeek: [] as ConversationListItem[],
    lastMonth: [] as ConversationListItem[],
  };

  chats.forEach((chat) => {
    const chatDate = new Date(chat.createdAt);
    chatDate.setHours(0, 0, 0, 0);

    if (chatDate.getTime() === today.getTime()) {
      groups.today.push(chat);
    } else if (chatDate.getTime() === yesterday.getTime()) {
      groups.yesterday.push(chat);
    } else if (chatDate >= lastWeek) {
      groups.lastWeek.push(chat);
    } else {
      groups.lastMonth.push(chat);
    }
  });

  logger.debug('[groupChatsByDate] Grouped results:', {
    today: groups.today.map((c) => ({
      id: c.id,
      title: c.title,
      createdAt: new Date(c.createdAt).toISOString(),
    })),
    yesterday: groups.yesterday.map((c) => ({
      id: c.id,
      title: c.title,
      createdAt: new Date(c.createdAt).toISOString(),
    })),
    lastWeek: groups.lastWeek.map((c) => ({
      id: c.id,
      title: c.title,
      createdAt: new Date(c.createdAt).toISOString(),
    })),
    lastMonth: groups.lastMonth.map((c) => ({
      id: c.id,
      title: c.title,
      createdAt: new Date(c.createdAt).toISOString(),
    })),
  });

  return groups;
}
